import { render } from "./HelpPageHome.vue?vue&type=template&id=0124d51c&scoped=true"
import script from "./HelpPageHome.vue?vue&type=script&lang=js"
export * from "./HelpPageHome.vue?vue&type=script&lang=js"

import "./HelpPageHome.vue?vue&type=style&index=0&id=0124d51c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0124d51c"]])

export default __exports__